import BusinessSummarySheet from "./BusinessSummarySheet";
import CompanyBankStatement from "./CompanyBankStatement";
import CompanyDocs from "./CompanyDocs";
import CompanyITR from "./CompanyITR";
import CollectGSTInfo from "./CollectGSTInfo";
import CollectSanctionLetter from "./CollectSanctionLetter";


export const remote = (node,key)=>node.appstore(`credit.remote.${node.props.documentKey}${key?'.'+key:''}`);
export const localstate = (node,key)=>node.appstore(`credit.state.${node.props.documentKey}${key?'.'+key:''}`);
export const saved = (node,key)=>{
  let localValue = localstate(node,key);
  let remoteValue  = remote(node,key);
  if(remoteValue instanceof Array) {
    return localValue instanceof Array && localValue.length>=remoteValue.length?localValue:remoteValue;
  } else {
    return localValue || remoteValue;
  }
};
export const documentSectionMap = (firmType)=>{
  switch(firmType) {
    case "indv":
      return {
        "company-doc":{
          "title":"Upload Business Documents",
          "component":CompanyDocs
        },
        "company-itr":{
          "title":"Upload ITR Documents",
          "component":CompanyITR
        },
        "gst-info":{
          "title":"Upload GST Info",
          "component":CollectGSTInfo
        },
        "sanction-letter":{
          "title":"Upload Sanction Letter",
          "component":CollectSanctionLetter
        },
        "bank-statements":{
          "title":"Upload Bank Statements",
          "component":CompanyBankStatement
        },
        "summary-sheets":{
          "title":"Upload Business Summary Sheets",
          "component":BusinessSummarySheet
        }
      };
    case "llp":
    case "ppc":
    case "gp":
    case "prop":
    return {
      "company-doc":{
        "title":"Upload Entity Documents",
        "component":CompanyDocs
      },
      "company-itr":{
        "title":"Upload Company's ITR",
        "component":CompanyITR
      },
      "gst-info":{
        "title":"Upload GST Info",
        "component":CollectGSTInfo
      },
      "sanction-letter":{
        "title":"Upload Sanction Letter",
        "component":CollectSanctionLetter
      },
      "bank-statements":{
        "title":"Upload Bank Statements",
        "component":CompanyBankStatement
      },
      "summary-sheets":{
        "title":"Upload Business Summary Sheets",
        "component":BusinessSummarySheet
      }
    }
  }
}

export const documentsTitles = {
  "company-doc":{
    "company_registration_copy":"Company Registration Copy",
    "cert_of_incoporation":"Certificate of Incorporation",
    "company_pancard":"Company Pancard",
    "partnership_deed":"Partner Ship Deed",
    "gst_registration":"GST Registration",
    "form_moa_aoa":"MOA & AOA",
    "remarks":"Remarks"
  },
  "company-itr":{
    "it_acknowledgement":"ITR Acknowledgment",
    "saral_copy":"Saral Copy",
    "it_return":"Complete IT Return",
    "computation_of_income":"Computation Of Income",
    "annual_report":"Annual Report",
    "tax_audit_report":"Tax Audit Report",
    "auditors_report":"Auditor's Report",
    "directors_report":"Director's Report",
    "balance_sheet":"P&L, Balance Sheet and Schedules",
    "form_3CA_3CD":"3CA & 3CD",
    "gstr_file":"GSTR File"
  },
  "bank-statements": {
    "bank_name": "Bank Name",
    "account_number":"Account Number",
    "tenor_in_months": "Tenor",
    "start_date":"From",
    "end_date":"Till",
    "type_of_acc": "Type Of Account",
    "month": "Month",
    "bank_statement": "Bank Statement",
    "sanction_letter":"Sanction Letter",
  },
  "summary-sheets":{
    "business_summary_template":"Business Summary Template",
    "sample_template":"Sample Template"
  }
}
//Upload Business Profile Sheet
//Upload Sanction Letter
export const documents = {
  "indv":{
    "company-doc":{
      "cert_of_incoporation": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "company_pancard": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "partnership_deed": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "gst_registration": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      }
    },
    "company-itr":{
      "it_acknowledgement": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "saral_copy": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "computation_of_income": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "auditors_report": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "balance_sheet": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "form_3CA_3CD": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "gstr_file": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED",
        "tenor_in_months": 12
      }
    },
    "bank-statements":[
      {
        "bank_name": "Axis Bank",
        "tenor_in_months": 12,
        "type_of_acc": "current",
        "month": "Jan 2022",
        "attachment_id": "attachmentId",
        "filename": "bank_statement_attachment.ext",
        "statement_status": "",
        "sanction_letter_attachment_id": "attachmentId",
        "sanction_letter_filename": "sanction_letter_attachment.ext",
        "sanction_letter_status": ""
      }
    ],
    "summary-sheets":{
      "business_summary_template":"",
      "sample_template":""
    }
  },
  "llp":{
    "company-doc":{
      "cert_of_incoporation": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "company_pancard": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "partnership_deed": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "gst_registration": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      }
    },
    "company-itr":{
      "it_acknowledgement": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "saral_copy": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "computation_of_income": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "auditors_report": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "balance_sheet": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "form_3CA_3CD": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "gstr_file": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED",
        "tenor_in_months": 12
      }
    },
    "bank-statements":[
      {
        "bank_name": "Axis Bank",
        "tenor_in_months": 12,
        "type_of_acc": "current",
        "month": "Jan 2022",
        "attachment_id": "attachmentId",
        "filename": "bank_statement_attachment.ext",
        "statement_status": "",
        "sanction_letter_attachment_id": "attachmentId",
        "sanction_letter_filename": "sanction_letter_attachment.ext",
        "sanction_letter_status": ""
      }
    ],
    "summary-sheets":{
      "business_summary_template":"",
      "sample_template":""
    }
  },
  "ppc":{
    "company-doc":{
      "cert_of_incoporation": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "company_pancard": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "form_moa_aoa": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "gst_registration": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      }
    },
    "company-itr":{
      "annual_report": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "tax_audit_report": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "it_acknowledgement": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "it_return": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "computation_of_income": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      // "directors_report": [
      //   {
      //     "attachment_id": "attachmentId",
      //     "filename": "attachment.ext",
      //     "password": "",
      //     "status": "",
      //     "assessment_year": "2022-23"
      //   }
      // ]
    },
    "bank-statements":[
      {
        "bank_name": "Axis Bank",
        "tenor_in_months": 12,
        "type_of_acc": "current",
        "month": "Jan 2022",
        "attachment_id": "attachmentId",
        "filename": "bank_statement_attachment.ext",
        "statement_status": "",
        "sanction_letter_attachment_id": "attachmentId",
        "sanction_letter_filename": "sanction_letter_attachment.ext",
        "sanction_letter_status": ""
      }
    ],
    "summary-sheets":{
      "business_summary_template":"",
      "sample_template":""
    }
  },
  "prop":{
    "company-doc":{
      "company_registration_copy": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "company_pancard": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "gst_registration": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      }
    },
    "company-itr":{
      "it_acknowledgement": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "saral_copy": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "computation_of_income": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "balance_sheet": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "form_3CA_3CD": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "gstr_file": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED",
        "tenor_in_months": 12
      }
    },
    "bank-statements":[
      {
        "bank_name": "Axis Bank",
        "tenor_in_months": 12,
        "type_of_acc": "current",
        "month": "Jan 2022",
        "attachment_id": "attachmentId",
        "filename": "bank_statement_attachment.ext",
        "statement_status": "",
        "sanction_letter_attachment_id": "attachmentId",
        "sanction_letter_filename": "sanction_letter_attachment.ext",
        "sanction_letter_status": ""
      }
    ],
    "summary-sheets":{
      "business_summary_template":"",
      "sample_template":""
    }
  },
  "gp":{
    "company-doc":{
      "company_registration_copy": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "company_pancard": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "partnership_deed": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      },
      "gst_registration": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED"
      }
    },
    "company-itr":{
      "saral_copy": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "computation_of_income": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "",
          "status": "",
          "assessment_year": "2022-23"
        }
      ],
      "balance_sheet": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "form_3CA_3CD": [
        {
          "attachment_id": "attachmentId",
          "filename": "attachment.ext",
          "password": "password",
          "status": "SUBMITTED",
          "assessment_year": "2022-23"
        }
      ],
      "gstr_file": {
        "attachment_id": "attachmentId",
        "filename": "attachment.ext",
        "password": "password",
        "status": "SUBMITTED",
        "tenor_in_months": 12
      }
    },
    "bank-statements":[
      {
        "bank_name": "Axis Bank",
        "tenor_in_months": 12,
        "type_of_acc": "current",
        "month": "Jan 2022",
        "attachment_id": "attachmentId",
        "filename": "bank_statement_attachment.ext",
        "statement_status": "",
        "sanction_letter_attachment_id": "attachmentId",
        "sanction_letter_filename": "sanction_letter_attachment.ext",
        "sanction_letter_status": ""
      }
    ],
    "summary-sheets":{
      "business_summary_template":"",
      "sample_template":""
    }
  }
}

